module.exports = __webpack_public_path__ + "img/anchor.f7219ecf.svg";